import React, { memo, useContext, useState } from 'react'
import { useDispatch } from 'react-redux'
import { Formik, Form, Field, ErrorMessage } from 'formik'
import * as Yup from 'yup'

// Internal imports
import { Spinner } from 'components/common/spinner'
import Button from 'components/common/button'
import { LanguageContext } from 'context/LanguageContext'
import { sendResetPasswordEmail } from 'modules/authentication/actions'
import Util from 'utils/Util'

const ResetPassword = memo(props => {
    const { strings } = useContext(LanguageContext)
    const [serverError, setServerError] = useState('')
    const [loader, setLoader] = useState(false)

    const dispatch = useDispatch()
    const validationSchema = Yup.object({
        email: Yup.string().matches(Util.getEmailValidationRegEx(), strings.invalidEmail).email(strings.invalidEmail).required(strings.emailError),
    })

    const closeModal = () => {
        if (props.cancelStep) props.cancelStep()
        else if (props.hide) {
            if (props.setShowResetPassword) props.setShowResetPassword()
            props.hide()
        }
    }

    const handleReset = async email => {
        setLoader(true) // Start the loader
        setServerError('') // Clear any previous errors

        dispatch(
            sendResetPasswordEmail({ email }, response => {
                setLoader(false) // Stop the loader
                if (response?.error_message) {
                    setServerError(response.error_message)
                } else if (props.nextStep) {
                    props.nextStep() // Only proceed if there is no error
                } else if (props.hide) {
                    if (props.setShowResetPassword) props.setShowResetPassword()
                    props.hide()
                }
            })
        )
    }

    return (
        <Formik
            initialValues={{ email: '' }}
            validationSchema={validationSchema}
            onSubmit={({ email }) => handleReset(email)}
        >
            {({ dirty, isValid }) => {
                const disabled = !dirty || !isValid
                return (
                    <>
                        {loader ? (
                            <Spinner height={'5rem'} width={'5rem'} />
                        ) : (
                            <Form className="form resetPasswordForm" autoComplete="off">
                                <div className="form-header">
                                    <p className="form-header-title">{strings.resetPassword}</p>
                                    <p className="form-header-sub">
                                        {strings.resetPasswordSubtitle}
                                    </p>
                                </div>
                                <div className="form-input">
                                    <div className="form-input-each input-group">
                                        <Field
                                            className="form-input-each-field"
                                            type="email"
                                            name="email"
                                            placeholder={strings.SIGN_IN_EMAIL}
                                            required
                                        />
                                        <div className={'form-input-each-error'}>
                                            &nbsp;
                                            <ErrorMessage name="email">
                                                {msg => <span>{msg}</span>}
                                            </ErrorMessage>
                                            {serverError && <span>{serverError}</span>}
                                        </div>
                                    </div>
                                </div>
                                <div className="form-buttons">
                                    <Button
                                        className="cancel cancel-lg"
                                        onClick={() => closeModal()}
                                    >
                                        {strings.backButton}
                                    </Button>
                                    <Button
                                        type="submit"
                                        disabled={disabled}
                                        className={`confirm confirm-lg ${disabled && 'disabled'}`}
                                    >
                                        {strings.sendButton}
                                    </Button>
                                </div>
                            </Form>
                        )}
                    </>
                )
            }}
        </Formik>
    )
})

export default ResetPassword
